<template>
  <div class="next-case">
    <a :href="`/cases/${locData.url_certain_lang}?from=case-page`" target="_blank" class="next-case__wrapper">
      <img :src="locData.image" class="case__company-logo case__company-logo--small d-block d-md-none" alt="" />
      <bimTextMain class="next-case__see-next" bold>Смотрите далее</bimTextMain>
      <bimTextAccent class="next-case__title my-6" bold>{{ locData.title }}</bimTextAccent>
      <BimTag :label="tagText" nohover />
      <div class="d-flex mt-9">
        <div class="d-none d-md-block">
          <img :src="locData.image" class="case__company-logo" alt="" />
        </div>
        <div class="flex-grow-1 ml-md-9 ml-0 d-flex flex-column justify-center">
          <bimTextDesc class="next-case__result-title mb-2" bold>итог</bimTextDesc>
          <bimTextMedium class="next-case__result">{{ locData.itog }}</bimTextMedium>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import bimTextAccent from "@bimlib/components/bimTextAccent"
import bimTextDesc from "@bimlib/components/bimTextDesc"
import bimTextMain from "@bimlib/components/bimTextMain"
import bimTextMedium from "@bimlib/components/bimTextMedium"
import BimTag from "@/athoms/BimTag"
export default {
  components: {
    bimTextAccent,
    bimTextDesc,
    bimTextMain,
    bimTextMedium,
    BimTag,
  },
  props: {
    data: {
      type: Object,
      required: true,
    }
  },
  computed: {
    locData() {
      return this.data.lang_versions[1]
    },
    tagText() {
      return this.locData.tags_lang
    }
  },
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/color";
@import "./src/front_white/sass/views/static/cases";
.next-case {
  display: flex;
  justify-content: center;
  padding: 100px 0;
  position: relative;
  color: $black-color;
  z-index: 1;

  @media screen and (max-width: 576px) {
    padding: 64px 0;
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    height: 100%;
    width: 100vw;
    z-index: -1;
    background-color: $white-color-50;
  }

  &__title ::v-deep .text__inner {
    @media screen and (max-width: 576px) {
      font-size: 20px !important;
    }
  }

  &__see-next {
    opacity: .5;
    line-height: 1.29;
    @media screen and (max-width: 576px) {
      font-size: 16px !important;
    }
  }

  &__result-title {
    opacity: .5;
    line-height: 1.83;
    letter-spacing: 0.5px;
  }

  &__result {
    line-height: 1.42;
    @media screen and (max-width: 576px) {
      font-size: 16px !important;
    }
  }
}

.next-case__wrapper {
  width: 100%;
}

.case__company-logo--small {
  position: absolute;
  top: 14px;
  right: 24px;
}
</style>
